import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const About = () => {
  const openResume = () => {
    window.open('https://docs.google.com/document/d/1NsEh-bq9mORTfyU9xAwARIvYAUX3jVlDWePB4nUKt30/export?format=pdf', '_blank');
  };

  return (
    <section className="about" id="about">
      <Container>
        <Row>
          <Col md={12}>
            <h2>About Me</h2>
            <p>
              With expertise in both web development and data analysis,
              I am passionate about using technology to drive innovation and
              bring a unique perspective to every project.
            </p>
            <p>
              I thrive in dynamic environments and quickly adapts to new technologies
              and frameworks. Whether building scalable web applications or analyzing complex
              datasets, I enjoy tackling challenges that push my skills.
            </p>
            <p>
              Committed to lifelong learning, I stay updated with the industry trends to
              deliver high-quality, modern solutions. My experience in collaboration and
              mentoring highlights my believe in teamwork and shared knowledge to foster progress.
            </p>
            <div className="button-container">
              <button type="button" onClick={openResume} className="resume">Get My Resume</button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About;
